import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Text } from '@hub/text';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function hasNoHours(openHourDay) {
  return !openHourDay || !openHourDay.day || !openHourDay.hours;
}
function hasNoDescription(text) {
  return !text || !text.description;
}
const DescriptionText = _ref => {
  let {
    text
  } = _ref;
  return hasNoDescription(text) ? null : /*#__PURE__*/_jsx(Text, {
    sx: {
      marginTop: 'spacing-xs'
    },
    "data-id": "trading-hours-line_index_DescriptionText_Text",
    children: text.description
  });
};
const TradingHoursLine = _ref2 => {
  let {
    openHourDay,
    sx,
    daySx,
    hoursSx
  } = _ref2;
  if (hasNoHours(openHourDay)) {
    return null;
  }
  const {
    hours,
    day,
    text
  } = openHourDay;
  return /*#__PURE__*/_jsxs(Stack, {
    "data-id": "trading-hours-line_index_DescriptionText_Stack",
    children: [/*#__PURE__*/_jsxs(Box, {
      "data-test-id": "opening-hours-entry",
      sx: _objectSpread({
        display: 'flex',
        fontWeight: day === 'Today' ? 'medium' : 'normal'
      }, sx),
      "data-id": "trading-hours-line_index_DescriptionText_Stack_Box",
      children: [/*#__PURE__*/_jsx(Text, {
        sx: _objectSpread({
          width: 'size-13'
        }, daySx),
        "data-id": "trading-hours-line_index_DescriptionText_Box_Text",
        children: day
      }), /*#__PURE__*/_jsx(Box, {
        sx: hoursSx,
        "data-id": "trading-hours-line_index_DescriptionText_Box_Box",
        children: hours.length > 1 ? /*#__PURE__*/_jsx("span", {
          "data-id": "trading-hours-line_index_DescriptionText_span",
          children: hours.map(hour => /*#__PURE__*/_jsx(Text, {
            "data-id": "trading-hours-line_index_DescriptionText_Text",
            children: hour
          }, hour))
        }) : /*#__PURE__*/_jsx(Text, {
          "data-id": "trading-hours-line_index_DescriptionText_Text_7",
          children: hours
        })
      })]
    }), /*#__PURE__*/_jsx(DescriptionText, {
      text: text,
      "data-id": "trading-hours-line_index_Stack_DescriptionText"
    })]
  });
};
export default TradingHoursLine;